// src/components/Navbar.jsx
import React, { useState } from 'react'; // 1. Importa useState
import { Link } from 'react-router-dom';

function Navbar({ isSticky }) {
  // 2. Crea una variable de estado para controlar si el menú está abierto o cerrado
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 3. Función para alternar el estado del menú
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`navbar navbar-expand-lg bg-white navbar-light sticky-top px-4 px-lg-5 ${isSticky ? 'shadow-sm' : ''}`}>
      <Link to="/" className="navbar-brand d-flex align-items-center">
        <img className="img-fluid me-3" src="/img/LOGO TAMA.png" alt="Logo TAMA Service" />
      </Link>

      {/* 4. Modifica el botón del menú hamburguesa */}
      <button 
        className="navbar-toggler" 
        type="button" 
        onClick={toggleMenu} // Usamos onClick en lugar de data-bs-toggle
        aria-controls="navbarCollapse"
        aria-expanded={isMenuOpen}
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* 5. Modifica el div del menú para que muestre u oculte según el estado */}
      <div className={`navbar-collapse collapse ${isMenuOpen ? 'show' : ''}`} id="navbarCollapse">
        <div className="navbar-nav mx-auto bg-light pe-4 py-3 py-lg-0">
          <Link to="/" className="nav-item nav-link active" onClick={() => setIsMenuOpen(false)}>Inicio</Link>

          <Link to="/contact" className="nav-item nav-link" onClick={() => setIsMenuOpen(false)}>Contactanos</Link>
        </div>
        <div className="h-100 d-lg-inline-flex align-items-center d-none">
          <a className="btn btn-square rounded-circle bg-light text-primary me-2" href="#"><i className="fab fa-facebook-f"></i></a>
          <a className="btn btn-square rounded-circle bg-light text-primary me-2" href="#"><i className="fab fa-twitter"></i></a>
          <a className="btn btn-square rounded-circle bg-light text-primary me-2" href="#"><i className="fab fa-linkedin-in"></i></a>
          <a className="btn btn-square rounded-circle bg-light text-primary me-0" href="#"><i className="fab fa-instagram"></i></a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;